






































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueTrix from 'vue-trix';
import store from '@/store';
import MainLayout from '@/layouts/Main.vue';
import TermsService from '@/services/terms';
import { Lang } from '@/lang/en/terms.ts';

@Component({
  components: {
    MainLayout,
    VueTrix,
  },
})
export default class Terms extends Vue {
  private lang: object = Lang;
  private termsName: string = 'terms-1-1';
  private isDisabled: boolean = true;
  private maxRows: number = 35;
  private termsContent: any = { id: null, version: null, content: '' };
  private termsVersion: any = 0;
  private parsedContent: any = '';

  private beforeCreate() {
    TermsService.Get();
  }

  get currentTerms() {
    return store.getters['Terms/getCurrentTerms'];
  }

  get labelText() {
    let label = `${Lang.textArea.label}`;
    if (Object.keys(this.currentTerms).length > 0) {
      label += ` Version ${this.currentTerms.version}`;
    }
    return label;

  }

  get clonedTerms() {
    return JSON.parse( JSON.stringify(this.currentTerms) );
  }

  private toggleDisabled() {
    const preview: any = document.getElementById('preview');
    this.isDisabled = !this.isDisabled;
    if (!this.isDisabled) {
      preview.style.display = 'none';
    } else {
      preview.style.display = 'block';
    }
  }

  private doEdit() {
    this.toggleDisabled();
  }

  private doCancel() {
    this.toggleDisabled();
    this.termsContent = JSON.parse( JSON.stringify(this.currentTerms) );
  }

  private doSave() {
    if (this.termsContent.content.length <= 0) {
      this.termsContent = JSON.parse( JSON.stringify(this.currentTerms) );
      this.toggleDisabled();
      return;
    }

    if (this.termsContent.content === store.getters['Terms/getCurrentTerms'].content) {
      this.toggleDisabled();
      return;
    }

    TermsService.Save(this.termsContent);
    this.toggleDisabled();
  }

  @Watch('clonedTerms', { deep: true })
  private onChange(newValue: any) {
    this.termsContent = newValue;
    this.termsVersion = newValue.version;
    if (window.document.readyState === 'complete') {
      const preview: any = document.getElementById('preview');
      preview.innerHTML = newValue.content;
    }
  }
}

